import { globals } from '../../globals'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_INVOICE_HISTORY_START = 'GET_INVOICE_HISTORY_START'
export const INVOICE_HISTORY_FETCHED = 'INVOICE_HISTORY_FETCHED'
export const INVOICE_HISTORY_FAILED = 'INVOICE_HISTORY_FAILED'
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function getInvoiceHistory (clientId) {
  return (dispatch) => {
    dispatch({ type: GET_INVOICE_HISTORY_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/clientbilling?clientid=${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: INVOICE_HISTORY_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: INVOICE_HISTORY_FAILED })
    })
  }
}

function createStore (data) {
  let invoiceObj = {
    0: {
      textValues: {
        Invoice: '',
        Amount: '',
        SendDt: '',
        ReceivedDt: '',
        DepositedDt: '',
        Status: '',
        Resent: '',
      }
    }
  }
  for (let i = 0; i <= data.length - 1; i++) {
    invoiceObj[data[i].BillingInfoId] = {
      textValues: {
        Invoice: data[i].Invoice,
        Amount: data[i].Amount,
        SendDt: data[i].SendDt || '',
        ReceivedDt: data[i].ReceivedDt || '',
        DepositedDt: data[i].DepositedDt || '',
        Status: data[i].Status,
        Resent: data[i].Resent || '',
      }
    }
  }
  return invoiceObj
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_INVOICE_HISTORY_START] : (state) => {
    return {
      ...state,
      isFetchingInvoice: true
    }
  },
  [INVOICE_HISTORY_FAILED] : (state) => {
    return {
      ...state,
      isFetchingInvoice: false
    }
  },
  [INVOICE_HISTORY_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingInvoice: false,
      formDataValue: {
        ...state.formDataValue,
        invoiceHistory: createStore(json),
      },
      renderData: {
        historyArray: json
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  formDataValue: {
    invoiceHistory: {}
  }
}
export default function clientBillingReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientBilling.js